import React from "react";
import { useLocation } from "react-router-dom";
import type { FooterSection } from "./types";

interface FooterProps {
  readonly sections: readonly FooterSection[];
  readonly onQuickInquiryClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export default function Footer({ sections, onQuickInquiryClick }: FooterProps) {
  const { pathname } = useLocation();

  const resolveHref = (href: string) => {
    if (href.startsWith("#") && pathname !== "/") {
      return `/${href}`;
    }
    return href;
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-8 h-8  rounded-lg flex items-center justify-center">
                <svg
                  viewBox="0 0 64 64"
                  className="w-8 h-8"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path
                    d="M10 8c0-3.3 2.7-6 6-6h8v44h18c3.3 0 6 2.7 6 6v6H16c-3.3 0-6-2.7-6-6V8z"
                    fill="#2563EB"
                  />
                  <rect x="28" y="12" width="14" height="14" rx="4" fill="#2563EB" />
                  <rect x="44" y="12" width="14" height="14" rx="4" fill="#2563EB" />
                  <rect x="28" y="28" width="14" height="14" rx="4" fill="#2563EB" />
                  <path d="M44 28h8l6 6v8h-8a6 6 0 0 1-6-6v-8z" fill="#2563EB" />
                </svg>
              </div>
              <span className="text-lg font-bold text-white">Liriworks</span>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Streamline your workforce management with our comprehensive platform.
            </p>
          </div>

          {/* Link columns */}
          {sections.map((section) => (
            <div key={section.title}>
              <h3 className="text-sm font-semibold text-white mb-3">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href === "#quick-inquiry" ? (
                      <button
                        type="button"
                        onClick={onQuickInquiryClick}
                        className="text-sm text-gray-400 hover:text-white transition-colors"
                      >
                        {link.label}
                      </button>
                    ) : (
                      <a
                        href={resolveHref(link.href)}
                        className="text-sm text-gray-400 hover:text-white transition-colors"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-gray-800 mt-6 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-gray-400">© {new Date().getFullYear()} Prodliri. All rights reserved.</p>
          {/* <div className="flex items-center gap-3">
            <a href="#linkedin" className="text-gray-400 hover:text-white transition-colors">
              <Linkedin className="w-4 h-4" />
            </a>
            <a href="#instagram" className="text-gray-400 hover:text-white transition-colors">
              <Instagram className="w-4 h-4" />
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
}